/**
 * Suggestion Box (/suggestion-box → POST /api/suggestions) limits, shared by
 * the client form and the route handler. Plain module (no 'use client') so a
 * Server Component, a Client Component and the route can all import it.
 *
 * The length caps mirror the roadmap_ideas CHECK constraints
 * (length(trim(title)) BETWEEN 1 AND 200, length(description) BETWEEN 1 AND 5000).
 */
export const SUGGESTION_TITLE_MAX = 200
export const SUGGESTION_DESCRIPTION_MAX = 5000

/** Per-user submissions allowed per hour. */
export const SUGGESTION_USER_LIMIT_PER_HOUR = 5
/** Per-IP submissions allowed per hour (looser: households / venues share an IP). */
export const SUGGESTION_IP_LIMIT_PER_HOUR = 20

/*
 * Silent bot checks (see src/app/api/suggestions/route.ts). A submission that
 * trips one gets the normal 201 success shape but nothing is stored. They only
 * stop naive bots — both fields are trivially forged — so Cloudflare Turnstile
 * is the real gate; these are a cheap extra layer.
 */

/**
 * Honeypot field name. The form renders a visually hidden, aria-hidden,
 * untabbable input with this name; people never see it, naive bots fill every
 * field. Any non-empty value → silently dropped.
 *
 * Deliberately NON-semantic: names like `website` / `url` / `email` get filled
 * by password managers' identity profiles (which ignore autocomplete=off and
 * aria-hidden), and that would silently drop a real member's suggestion.
 */
export const SUGGESTION_HONEYPOT_FIELD = 'sb_extra'

/**
 * Minimum time between the form rendering and the submit, in milliseconds,
 * measured on the CLIENT with performance.now() and sent as `elapsedMs` (an
 * elapsed duration, not a timestamp, so client/server clock skew can't matter).
 * Present but faster / non-numeric → silently dropped. Absent → not judged
 * (Turnstile decides), so a tab still running an older bundle isn't dropped.
 * The form itself waits out any remainder before posting, so a real member
 * (e.g. one sending a restored draft straight after signing back in) is never
 * caught by it.
 */
export const SUGGESTION_MIN_FILL_MS = 3000
